import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";

import Icon from "Common/Icon";

import type { MedicalPlan } from "Utils/types";

type Props = {
  plan: MedicalPlan;
  className?: string;
};

export default function EligibilityBadge({ plan, className }: Props) {
  if (plan.is_company_eligible_for_plan === "eligible") {
    return (
      <span className={classnames("PlanBadge", className)}>
        <Icon className={classnames("PlanBadge__icon--check")} icon="check-circle" flavor="solid" />
        &nbsp;Eligible
      </span>
    );
  }
  if (plan.is_company_eligible_for_plan === "ineligible") {
    return !isIntuit() ? (
      ""
    ) : (
      <span className={classnames("PlanBadge", className)}>
        <Icon className={classnames("PlanBadge__icon--times")} icon="times-circle" flavor="solid" />
        &nbsp;Ineligible
      </span>
    );
  }
  return null;
}
